import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ArticleCard from "@/components/feature/ArticleCard";
import SectionHeading from "@/components/feature/SectionHeading";
import NewsletterForm from "./components/NewsletterForm";
import usePageMeta, { useJsonLd } from "@/hooks/usePageMeta";
import { siteMeta, categories, articles } from "@/mocks/articles";

function Ticker() {
  const list = [
    "镜头之外的营业图鉴：明星与公众之间的真实边界",
    "流量退潮之后：认真做内容的人正在上岸",
    "老熟人回归潮：经典面孔为何再次翻红",
    "当公众议题遇上热搜：理性讨论的几条准则",
    "新一代创业者画像：慢下来，也是一种策略",
  ];
  const [i, setI] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setI((v) => (v + 1) % list.length), 4000);
    return () => clearInterval(t);
  }, [list.length]);
  return (
    <div className="border-b border-primary-200 bg-primary-50">
      <div className="mx-auto flex max-w-6xl items-center gap-3 px-4 py-2 md:px-6">
        <span className="flex shrink-0 items-center gap-1 whitespace-nowrap rounded-sm bg-primary-500 px-2 py-0.5 text-xs font-bold text-background-50">
          <i className="ri-flashlight-fill"></i>
          今日看点
        </span>
        <p className="min-w-0 flex-1 truncate text-sm text-primary-900">{list[i]}</p>
        <span className="hidden shrink-0 items-center gap-1 whitespace-nowrap text-xs text-foreground-500 sm:flex">
          <i className="ri-hashtag"></i>
          持续更新中
        </span>
      </div>
    </div>
  );
}

const editorialNotes = [
  { icon: "ri-focus-3-line", title: "先核实，再盘点", text: "对存在争议的信息，我们坚持标注来源与状态，宁可少发，不发未经证实的内容。" },
  { icon: "ri-scales-3-line", title: "不站队，不诛心", text: "就事论事地讨论行为与规则，不做人格否定，不让情绪替代理性判断。" },
  { icon: "ri-user-heart-line", title: "尊重隐私与人格", text: "拒绝针对个人的网络暴力，对存疑与涉私内容一律谨慎处理，保护每个人免于被误读。" },
];

export default function Home() {
  usePageMeta({
    title: "每日黑料_每日黑料明星黑料_每日黑料网红黑料_每日黑料公众人物盘点_每日黑料人物",
    description:
      "每日黑料是面向大众的公众人物动态与热议话题盘点站，持续收录明星、网红、商界人物与公共人物的高低起伏。看人物内幕、追热门盘点，从每日黑料人物入口开启，谁被翻旧账、谁出新瓜，一站看尽。",
    keywords: "每日黑料,每日黑料明星黑料,每日黑料网红黑料,每日黑料人物,公众人物盘点,明星黑料,网红盘点,人物动态",
    canonicalPath: "/",
  });

  useJsonLd([
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: siteMeta.brand,
      alternateName: "每日黑料人物盘点",
      description: siteMeta.desc,
      inLanguage: "zh-CN",
    },
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: siteMeta.brand,
      slogan: siteMeta.tagline,
      email: siteMeta.email,
    },
  ]);

  const featured = articles[0];
  const subList = articles.slice(1, 6);
  const trending = articles;
  const deep = [articles[2], articles[3], articles[6], articles[7]];

  return (
    <>
      <Ticker />

      {/* 今日头版 */}
      <section className="mx-auto max-w-6xl px-4 pt-8 md:px-6" aria-labelledby="headline-title">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
          <div className="lg:col-span-2">
            <Link
              to={`/article/${featured.slug}`}
              className="group relative block overflow-hidden rounded-lg"
            >
              <div className="aspect-[16/9] overflow-hidden">
                <img
                  src={featured.cover}
                  alt={`${featured.title} 头版深度盘点`}
                  title={`${featured.title} 每日黑料头版`}
                  className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-foreground-950 via-foreground-950/70 to-transparent p-5 md:p-6">
                <span className="inline-flex items-center gap-1 rounded-sm bg-accent-500 px-2 py-0.5 text-xs font-bold text-foreground-950">
                  <i className="ri-award-line"></i>
                  头版深度 · {featured.catName}
                </span>
                <h2 className="mt-3 font-heading text-2xl font-black leading-tight text-background-50 md:text-3xl">
                  {featured.title}
                </h2>
                <p className="mt-2 line-clamp-2 hidden text-sm text-background-200 sm:block">
                  {featured.lead}
                </p>
                <p className="mt-3 flex items-center gap-3 text-xs text-background-300">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {featured.date}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {featured.views}阅读
                  </span>
                </p>
              </div>
            </Link>
          </div>
          <div className="flex flex-col justify-between gap-1">
            <div className="mb-2 flex items-center justify-between">
              <h3 className="font-heading text-lg font-black text-foreground-950">今日更多看点</h3>
              <Link to="/category/star" className="flex items-center gap-1 text-xs text-primary-700 hover:text-primary-600">
                栏目入口<i className="ri-arrow-right-s-line"></i>
              </Link>
            </div>
            {subList.map((a) => (
              <ArticleCard key={a.slug} article={a} layout="row" />
            ))}
          </div>
        </div>
      </section>

      {/* 栏目四宫格 */}
      <section className="bg-secondary-50/60 py-10 md:py-14" aria-label="栏目分类">
        <div className="mx-auto max-w-6xl px-4 md:px-6">
          <SectionHeading
            tag="COLUMNS"
            title="按人物圈层盘点"
            sub="四个常设栏目，覆盖明星、网红、商界人物与公共人物，长期追踪不同圈层人物的起落与热议走向。"
          />
          <div className="mt-7 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {categories.map((c) => (
              <Link
                key={c.key}
                to={`/category/${c.key}`}
                className="group relative block overflow-hidden rounded-lg border border-foreground-900/10"
              >
                <div className="aspect-[4/5] overflow-hidden sm:aspect-square">
                  <img
                    src={c.image}
                    alt={`${c.name} 栏目封面`}
                    title={`${c.name} - 每日黑料栏目`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-foreground-950 via-foreground-950/75 to-transparent p-4 pt-12">
                  <p className="font-label text-[11px] tracking-[0.25em] text-accent-300">{c.en}</p>
                  <h3 className="mt-1 text-lg font-bold text-background-50">{c.name}</h3>
                  <p className="mt-1 line-clamp-1 text-xs text-background-300">{c.desc}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* 热议榜 + 编辑部观察 */}
      <section className="mx-auto max-w-6xl px-4 py-10 md:px-6 md:py-14" aria-label="热议与编辑观察">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-5">
          <div className="lg:col-span-3">
            <SectionHeading
              tag="TRENDING"
              title="本周热议榜"
              sub="谁被翻旧账，谁又出新瓜，按热度与讨论质量综合排行的本周人物看点。"
            />
            <ol className="mt-5 space-y-0">
              {trending.map((a, idx) => (
                <li key={a.slug}>
                  <Link
                    to={`/article/${a.slug}`}
                    className="group flex items-center gap-4 border-b border-foreground-900/10 py-3.5 last:border-0"
                  >
                    <span
                      className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-sm font-label text-lg ${
                        idx < 3
                          ? "bg-primary-500 text-background-50"
                          : "bg-background-200 text-foreground-700"
                      }`}
                    >
                      {String(idx + 1).padStart(2, "0")}
                    </span>
                    <div className="min-w-0 flex-1">
                      <h4 className="line-clamp-1 text-[15px] font-medium text-foreground-950 transition-colors group-hover:text-primary-700">
                        {a.title}
                      </h4>
                      <p className="mt-0.5 text-xs text-foreground-500">
                        {a.catName} · {a.date}
                      </p>
                    </div>
                    <span className="hidden shrink-0 items-center gap-1 text-xs text-foreground-500 sm:flex">
                      <i className="ri-fire-line text-primary-500"></i>
                      {a.views}
                    </span>
                    <i className="ri-arrow-right-line shrink-0 text-foreground-300 transition-transform group-hover:translate-x-1 group-hover:text-primary-600"></i>
                  </Link>
                </li>
              ))}
            </ol>
          </div>

          <div className="lg:col-span-2">
            <SectionHeading tag="EDITORIAL" title="编辑部观察" sub="关于盘点伦理与内容原则，编辑部的几条自省。" />
            <div className="mt-5 space-y-4">
              {editorialNotes.map((n) => (
                <div
                  key={n.title}
                  className="rounded-lg border border-foreground-900/10 bg-background-100/70 p-5"
                >
                  <div className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-500 text-foreground-950">
                    <i className={`${n.icon} text-xl`}></i>
                  </div>
                  <h4 className="mt-3 text-base font-bold text-foreground-950">{n.title}</h4>
                  <p className="mt-1.5 text-sm leading-6 text-foreground-600">{n.text}</p>
                </div>
              ))}
              <Link
                to="/about"
                className="flex items-center justify-between rounded-lg border border-primary-200 bg-primary-50 px-5 py-4 transition-colors hover:bg-primary-100"
              >
                <span className="text-sm font-medium text-primary-800">了解完整的内容原则与站内机制</span>
                <i className="ri-arrow-right-line text-primary-600"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* 行业深度 / 深度话题 */}
      <section className="border-y border-foreground-900/10 bg-secondary-50/40 py-10 md:py-14" aria-label="深度话题">
        <div className="mx-auto max-w-6xl px-4 md:px-6">
          <SectionHeading
            tag="DEEP DIVE"
            title="本周深度专题"
            sub="不止于围观，用更长的篇幅聊透商业、公共议题与行业走向。"
            more={{ to: "/category/shangjie", label: "查看商界栏目" }}
          />
          <div className="mt-7 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {deep.map((a) => (
              <ArticleCard key={a.slug} article={a} layout="grid" />
            ))}
          </div>
        </div>
      </section>

      {/* 内容原则条幅 */}
      <section className="mx-auto max-w-6xl px-4 py-10 md:px-6" aria-label="内容原则">
        <div className="overflow-hidden rounded-lg bg-foreground-950 text-background-100">
          <div className="grid grid-cols-1 md:grid-cols-3">
            <div className="p-6 md:p-8 md:col-span-2">
              <span className="font-label text-xs tracking-[0.3em] text-accent-400">OUR PROMISE</span>
              <h3 className="mt-2 font-heading text-xl font-black text-background-50 md:text-2xl">
                我们把「分寸」放在「劲爆」之前
              </h3>
              <p className="mt-3 max-w-2xl text-sm leading-6 text-background-200">
                做人物盘点，最难的不是挖料，而是守住边界。面对未经证实的传言、涉及隐私的细节与可能伤人的标题，
                我们宁可错过热点，也不消费当事人。让围观有质量，让八卦有底线，是这份工作的全部尊严。
              </p>
              <div className="mt-5 flex flex-col gap-3 sm:flex-row">
                <Link
                  to="/faq"
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-medium text-foreground-950 transition-colors hover:bg-accent-600"
                >
                  阅读内容 FAQ
                </Link>
                <Link
                  to="/contact"
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-200/40 px-5 py-2.5 text-sm font-medium text-background-100 transition-colors hover:bg-background-100 hover:text-foreground-950"
                >
                  提供核实线索
                </Link>
              </div>
            </div>
            <div className="hidden bg-foreground-800/40 p-8 md:flex md:flex-col md:justify-center md:border-l md:border-background-200/10">
              <p className="font-label text-6xl text-primary-500">24</p>
              <p className="mt-2 text-sm leading-6 text-background-200">
                小时热榜之外，我们更在意一条信息在
                <span className="font-bold text-accent-400"> 发出前是否经得起三问</span>：
                来源可靠吗？上下文完整吗？会不会伤害到无关的人？
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 订阅 */}
      <section className="border-t border-foreground-900/10 bg-background-100/60 py-10 md:py-14" aria-label="订阅">
        <div className="mx-auto max-w-6xl px-4 md:px-6">
          <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:items-center">
            <div>
              <SectionHeading
                tag="NEWSLETTER"
                title="每周精选 · 按时盘点"
                sub="每周挑出 3 条最值得关注的人物动态与深度观察，去芜存菁，直达邮箱。"
              />
              <ul className="mt-5 grid grid-cols-1 gap-3 sm:grid-cols-2">
                {["只发干货，不刷存在感", "可随时一键退订", "优先收到深度长文", "编辑部精选，人工把关"].map((t) => (
                  <li key={t} className="flex items-center gap-2 text-sm text-foreground-700">
                    <i className="ri-checkbox-circle-fill text-primary-600"></i>
                    {t}
                  </li>
                ))}
              </ul>
            </div>
            <div className="rounded-lg border border-foreground-900/10 bg-background-50 p-6 md:p-7">
              <h3 className="text-lg font-bold text-foreground-950">订阅 {siteMeta.brand}</h3>
              <p className="mt-1 text-sm text-foreground-600">填写邮箱，即可加入读者俱乐部。</p>
              <div className="mt-5">
                <NewsletterForm />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}